module.exports = __webpack_public_path__ + "static/media/logo-blue.2b4fc254.svg";